import KSchedule from '@components/k-schedule';
import { SadaSchedule } from './styles';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const Schedule = () => (
  <SadaSchedule>
    <KSchedule initial="all" />
  </SadaSchedule>
);

export default Schedule;
